<template>
    <div class="record-cell" @click="$emit('clickItem', item)">
        <h5 class="title">{{ title }}</h5>
        <div class="cell-item">
            <div class="content">测评得分：{{ total }}</div>
            <div class="content" style="text-align: right;">测评结果：{{ result }}</div>
        </div>
        <div class="cell-item">
            <div class="content">测试时间：{{ gmtCreate }}</div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
    props: {
        item: Object
    },
    computed: {
        gmtCreate() {
            return this.item.gmtCreate ? dayjs(this.item.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : ''
        },
        title() {
            return this.item?.title || '-'
        },
        total() { 
            return this.item?.total || '-'
        },
        result() {
            return this.item?.result || '-'
        }
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    },
}
</script>
<style scoped lang='scss'>
.record-cell {
    margin: 10px 20px;
    width: calc(100% - 40px);
    padding: 10px 15px;
    height: 94px;
    background: #FFFFFF;
    border-radius: 10px;
    box-sizing: border-box;
    .title {
        width: 100%;
        height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #585858;
        line-height: 20px;
    }

    .cell-item {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;

        .content {
            flex: 1;
            height: 17px;
            font-weight: 400;
            font-size: 12px;
            color: #888888;
            line-height: 17px;
        }
    }

}
</style>